import { useFormContext } from "react-hook-form";
import TextArea from "@/components/TextArea/TextArea";
import {
  informationFieldConfigValueSchema,
  type IInformationFieldConfigValue,
} from "@/api/Patients";
import { useLingui } from "@lingui/react/macro";

export type FlagsInputFields = {
  flags: string;
};

const FlagsInput = ({
  flagsFieldConfig,
}: {
  flagsFieldConfig: IInformationFieldConfigValue;
}) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<FlagsInputFields>();

  return (
    <TextArea
      label={t`Flaggningar`}
      showOptionalLabel={
        flagsFieldConfig === informationFieldConfigValueSchema.enum.optional
      }
      errorMessage={errors.flags?.message}
      {...register("flags", {
        required: {
          value:
            flagsFieldConfig ===
            informationFieldConfigValueSchema.enum.required,
          message: t`Ange information om flaggningar`,
        },
      })}
    />
  );
};

export default FlagsInput;
